import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { useForm } from '@/features/pos/components/OrderFinalization/form'
import { PosMode } from '@/features/pos/types'
import { FC, ReactNode } from 'react'
import { FormProvider } from 'react-hook-form'

interface FormProps {
    children: ReactNode
    posMode: PosMode
    defaultDeliveryTypeCategory?: DeliveryTypeCategory
}

const Form: FC<FormProps> = ({ children, posMode, defaultDeliveryTypeCategory }) => {
    const methods = useForm(posMode, defaultDeliveryTypeCategory)

    return <FormProvider {...methods}>{children}</FormProvider>
}

export default Form
